enum EReduxStoreInitialState {

    DEFAULT = 1,
    ARRAY = 2,
    OBJECT = 3

};

export default EReduxStoreInitialState;
